module.exports = __webpack_public_path__ + "img/defaultAnnouncement2.6e275ebd.jpg";